import React, { memo } from "react"; 
import { features } from '../data/featureData';
import SingleFeatureDisplay from './SingleFeatureDisplay';

interface FeatureScrollProps {
  scrollY: number;
  activeSection: number;
  previousActiveSection: number | null; // <<< NEW PROP
  viewportHeight: number;
  sectionStartVhValues: number[];
  isVisible: boolean;
  isInteractionReady: boolean;
}

const FeatureScroll: React.FC<FeatureScrollProps> = ({
  scrollY,
  activeSection,
  previousActiveSection, // <<< NEW PROP
  viewportHeight,
  sectionStartVhValues,
  isVisible,
  isInteractionReady,
}) => {
  const containerStyle: React.CSSProperties = {
    opacity: isVisible ? 1 : 0,
    pointerEvents: isVisible ? 'auto' : 'none',
    transition: 'opacity 0.4s ease-in-out',
  };

  return (
    <div className="feature-scroll-list-container" style={containerStyle}>
      {features.map((featureItem, arrayIndex) => {
        const sectionIndexOfFeature = 12 + arrayIndex;

        // <<< REVISED LOGIC: RENDER BOTH ACTIVE AND PREVIOUS FOR TRANSITIONS >>>
        const isCurrentlyActive = activeSection === sectionIndexOfFeature;
        const wasPreviouslyActive = previousActiveSection === sectionIndexOfFeature;

        // Only render if it's the active feature, the one just leaving, or the one next/prev
        const proximity = Math.abs(activeSection - sectionIndexOfFeature);
        if (!isCurrentlyActive && !wasPreviouslyActive && proximity > 1) {
            return null;
        }

        return (
          <SingleFeatureDisplay
            key={featureItem.id}
            feature={featureItem}
            sectionIndex={sectionIndexOfFeature}
            isActiveSection={isCurrentlyActive}
            scrollY={scrollY}
            viewportHeight={viewportHeight}
            sectionStartVhValues={sectionStartVhValues}
            isInteractionReady={isInteractionReady}
          />
        );
      })}
    </div>
  );
};

export default memo(FeatureScroll);